var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  SearchPostalCode = require('_js/search-postal-code');

function RegistrationPersonalInfo(params) {
  var self = this;

  if (params.step === undefined) {
    throw 'No steps parameter passed to this component!';
  }

  self.parent = params.parent;
  self.API = params.api;

  self.componentActive = false;
  self.step = params.step;
  self.currentStep = ko.observable(self.parent.currentStep());

  self.$htmlBody = $('html, body');

  self.currentInputField = 0;

  // Determine if this page is the current step.
  self.parent.currentStep.subscribe(function(val) {
    if (val === self.step()) {
      var regData = sessionStorage.getItem('rn-registration');

      if (regData !== undefined && regData !== null) {
        var parsedRegData = JSON.parse(regData);
        if (parsedRegData.personalInfo !== undefined) {
          parsedRegData.personalInfo.person = null;
          self.parent.storeValuesForStep(
            'personalInfo',
            parsedRegData.personalInfo
          );
        }
      }
      self.activateComponent();
    } else {
      self.deactivateComponent();
    }
  });

  self.activeModal = ko.observable(false);
  self.modalTitle = ko.observable('Er du bruker');
  self.modalText = ko.observable(self.parent.text.alreadyUserInformation);
  self.modalUsers = ko.observable(0);
  self.modalUserConfirmation = ko.observable('1');
  self.searchQuery = ko.observable();
  self.results = ko.observableArray([]);
  self.hasSearched = ko.observable(false);
  self.resultOption = ko.observable(0);
  self.isExistingUserMember = ko.computed(function() {
    if (self.results().length <= 0) {
      return false;
    }
    if (self.modalUsers() >= self.results().length) {
      return false;
    }
    return (
      self.results()[self.modalUsers()].IsMember &&
      !self.results()[self.modalUsers()].IsAgencyLeaderMember
    );
  });

  self.isExistingUserStudentOrTraineeMemberAndSignUpTypePerson = ko.computed(
    function() {
      if (self.results().length <= 0) {
        return false;
      }
      if (self.modalUsers() >= self.results().length) {
        return false;
      }
      return (
        self.results()[self.modalUsers()].IsStudentOrTraineeMember &&
        self.parent.signuptype === 'person'
      );
    }
  );

  self.searchPerson = function() {
    var url =
      self.API.getPersonById +
      '?aktorId=' +
      encodeURIComponent(self.searchQuery());
    APIHelper.get(
      url,
      function(data) {
        self.hasSearched(true);
        self.results(data);
      },
      function(response) {
        var location = window.location.href || document.URL;
        APIHelper.post('/api/log/error', {
          message: 'API-error: registration-personal-info.js',
          context: location,
          parameters: [
            'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
            'platform: ' + navigator.platform,
            'responseText: ' + response.responseText,
            'status: ' + response.status,
            'statusText: ' + response.statusText,
            'requestUrl: ' + url
          ]
        });
      }
    );
  };

  self.givenName = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });
  self.surname = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });
  // Birthnumber / fødselsnummer / social security number
  self.birthNumber = ko.observable().extend({
    required: [
      {
        type: 'isLength',
        message:
          self.parent.errorMessages.wrongNumberOfDigitsSocialSecurityNumber,
        length: 11
      },
      { type: 'isNumber', message: self.parent.errorMessages.NotANumber },
      {
        type: 'isValidPersonNumber',
        message: self.parent.errorMessages.invalidSocialSecurityNumber,
        api: self.API.isValidPersonNumber
      }
    ]
  });
  self.mobileNumber = ko.observable().extend({
    required: [
      {
        type: 'isNumber',
        message: self.parent.errorMessages.invalidPhoneNumber
      }
    ]
  });

  self.email = ko.observable().extend({
    required: [
      { type: 'isOptional', message: 'optional' },
      { type: 'isEmail', message: self.parent.errorMessages.invalidEmail }
    ]
  });
  self.emailWork = ko.observable().extend({
    required: [
      { type: 'isEmail', message: self.parent.errorMessages.invalidEmail }
    ]
  });

  self.postCareOf = ko.observable().extend({
    required: [{ type: 'isOptional', message: 'optional' }]
  });

  self.postAddress = ko.observable().extend({
    required: [{ type: 'isOptional', message: 'optional' }]
  });
  self.postalCode = ko.observable().extend({
    required: [
      {
        type: 'isNumber',
        message: self.parent.errorMessages.notANumber
      },
      {
        type: 'isLength',
        message: self.parent.errorMessages.wrongNumberOfDigitsPostalCode,
        length: 4
      }
    ]
  });
  self.postalPlace = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });

  self.isBureauMemberOfRn = ko.observable('2');

  self.requiredFields = [
    self.givenName,
    self.surname,
    self.mobileNumber,
    self.emailWork,
    self.postalCode
    // self.postalPlace
  ];

  if (self.parent.signuptype !== 'studentandpractice') {
    self.requiredFields.push(self.birthNumber);
  }

  var regData = sessionStorage.getItem('rn-registration');

  if (regData !== undefined && regData !== null) {
    var parsedRegData = JSON.parse(regData);
    if (parsedRegData.personalInfo !== undefined) {
      this.populateInputFromStore(parsedRegData.personalInfo);
    }
  }

  var searchPostalCode = new SearchPostalCode(null, self.postalPlace);

  self.postalCode.subscribe(function(val) {
    searchPostalCode.searchForCity(val);
  });
}

RegistrationPersonalInfo.prototype.afterMarkupRender = function() {
  var self = this;
  self.inputFields = $('.form-personal-info').find(':input:not([readonly])');

  self.activateComponent();
};

RegistrationPersonalInfo.prototype.activateComponent = function() {
  var self = this;
  // Since this is called in the constructor we need to do verify that we are at the correct step.
  if (self.step() === self.parent.currentStep()) {
    self.componentActive = true;
    self.parent.addInputControlForPage(self.inputFields);
  }
};

RegistrationPersonalInfo.prototype.deactivateComponent = function() {
  var self = this;
  // If the component is already deactivated we can just exit the function.
  if (!self.componentActive) {
    return;
  }
  // Only deactivate the component if the current step is not this step.
  if (self.step() !== self.parent.currentStep()) {
    self.componentActive = false;
    self.parent.removeInputControlForPage(self.inputFields);
  }
};

RegistrationPersonalInfo.prototype.submitForm = function() {};

RegistrationPersonalInfo.prototype.triggerModal = function() {
  this.activeModal(!this.activeModal());
};

RegistrationPersonalInfo.prototype.closeModal = function() {
  this.hasSearched(false);
  this.results([]);
  this.activeModal(false);
};

RegistrationPersonalInfo.prototype.populateInputFromStore = function(store) {
  this.givenName(store.givenName);
  this.surname(store.surname);
  this.birthNumber(store.birthNumber);
  this.mobileNumber(store.mobileNumber);
  this.email(store.emailPrivate);
  this.emailWork(store.email);
  this.postCareOf(store.postCareOf);
  this.postAddress(store.postAddress);
  this.postalCode(store.postalCode);
  this.postalPlace(store.postalPlace);
};

RegistrationPersonalInfo.prototype.createStoreObject = function() {
  var retObj = {
    givenName: this.givenName(),
    surname: this.surname(),
    birthNumber: this.birthNumber(),
    mobileNumber: this.mobileNumber(),
    emailPrivate: this.email(),
    email: this.emailWork(),
    postCareOf: this.postCareOf(),
    postAddress: this.postAddress(),
    postalCode: this.postalCode(),
    postalPlace: this.postalPlace()
  };
  if (this.hasSearched()) {
    retObj.person = this.results()[this.modalUsers()];
  } else {
    retObj.person = undefined;
  }

  // Store all the observable values into an object.
  return retObj;
};

RegistrationPersonalInfo.prototype.storeValues = function() {
  this.parent.storeValuesForStep('personalInfo', this.createStoreObject());
};

RegistrationPersonalInfo.prototype.validateInputOnStep = function() {
  return this.parent.validateFields(this.requiredFields);
};

RegistrationPersonalInfo.prototype.checkIfExistingUser = function() {
  var self = this;
  var url =
    self.API.getPersonExists +
    '?phoneNumber=' +
    encodeURIComponent(self.mobileNumber()) +
    '&email=' +
    encodeURIComponent(self.emailWork());

  if (self.birthNumber()) {
    url += '&personNumber=' + encodeURIComponent(self.birthNumber());
  }

  APIHelper.get(
    url,
    function(data) {
      self.hasSearched(true);
      self.results(data);

      if (data.length === 0) {
        self.storeValues();
        self.parent.nextStep();
      } else {
        self.activeModal(true);
      }
    },
    function() {
      // TODO: HANDLE ERROR;
    }
  );
};

RegistrationPersonalInfo.prototype.modalNextStep = function() {
  // 1: Store values.
  this.storeValues();

  // 2: Close the modal.
  this.activeModal(false);

  // 3: Continue to the next step.
  this.parent.nextStep();
};

RegistrationPersonalInfo.prototype.previousStep = function() {
  this.parent.previousStep();
};

RegistrationPersonalInfo.prototype.nextStep = function() {
  // 1: Validate step. If successful, goto next step.
  if (!this.validateInputOnStep()) {
    var location = window.location.href || document.URL;
    APIHelper.post('/api/log/error', {
      message: 'NOT-VALIDATED: registration-personal-info.js',
      context: location,
      parameters: [
        'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
        'platform: ' + navigator.platform
      ]
    });
    return;
  }

  // 2: Store values inputted by the user into Storage.
  // this.storeValues();

  // 3: Check if user already exists.
  this.checkIfExistingUser();

  // 4: Continue if member does not exist.
  // TODO.
};

RegistrationPersonalInfo.prototype.destroy = function() {};

module.exports = RegistrationPersonalInfo;
